"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HospiceTools = void 0;
const EmrConstants_1 = require("../../EmrConstants");
const helper_1 = require("../../helper");
class HospiceTools {
    constructor() { }
    parse(pastedData, event, callbackEmit) {
        var _a;
        console.log("Calling parser: hospiceTools");
        try {
            const parseData = this.parseData(pastedData);
            callbackEmit({ parseData });
        }
        catch (error) {
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : error,
                errorStack: error.stack,
            });
        }
    }
    parseData(pastedData) {
        var _a, _b;
        const lines = pastedData.split("\n");
        const mrn = (_b = (_a = pastedData.match(/MR\s*#:?\s*([A-Za-z0-9]+)/)) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.trim();
        return Object.assign(Object.assign({}, (mrn && { mrn })), { patientInfo: this.getPatientInfo(lines), insurance: this.getInsurance(lines), info: {
                physician: this.getPhysician(lines),
                pharmacy: this.getPharmacy(lines),
                careGiver: this.getCareGiver(lines),
            } });
    }
    getPatientInfo(lines) {
        let firstName = "";
        let lastName = "";
        let phoneNo = "";
        let placeName = "";
        let dob;
        for (const line of lines) {
            // Patient Name: MARGARITA BENTANCUR MR #: 87484
            if (line.startsWith("Patient Name:")) {
                const nameSection = line
                    .replace("Patient Name:", "")
                    .split("MR #:")[0]
                    .trim();
                const nameParts = nameSection.split(" ");
                if (nameParts.length >= 2) {
                    firstName = nameParts[0];
                    lastName = nameParts.slice(1).join(" ");
                }
            }
            // Birth Date: 11/28/1930
            if (line.startsWith("Birth Date:")) {
                const dobStr = line.replace("Birth Date:", "").split("SSN:")[0].trim();
                if (dobStr) {
                    dob = (0, helper_1.buildLocalDate)(dobStr);
                }
            }
        }
        // Get address from Location section (line after "Current Location:" section's "Address:")
        const locationIndex = lines.findIndex(l => l.startsWith("Location Type:"));
        if (locationIndex !== -1) {
            for (let i = locationIndex; i < lines.length; i++) {
                if (lines[i].startsWith("Address:") && lines[i].length > 8) {
                    placeName = lines[i].replace("Address:", "").trim();
                    break;
                }
            }
        }
        return {
            firstName,
            lastName,
            phoneNo,
            address: {
                placeName,
                apartmentNo: "",
            },
            dob,
        };
    }
    getInsurance(lines) {
        for (const line of lines) {
            if (line.startsWith("Payer Name:")) {
                return line.replace("Payer Name:", "").trim();
            }
        }
        return "";
    }
    getPhysician(lines) {
        for (const line of lines) {
            // Attending Physician Name: SAMANI, KAVEH NPI #: 1720118458
            if (line.startsWith("Attending Physician Name:")) {
                const nameSection = line
                    .replace("Attending Physician Name:", "")
                    .split("NPI")[0]
                    .trim();
                // Convert "SAMANI, KAVEH" to "Kaveh Samani"
                const nameParts = nameSection.split(",").map(p => p.trim());
                let name = "";
                if (nameParts.length >= 2) {
                    name = (0, helper_1.toTitleCase)(`${nameParts[1]} ${nameParts[0]}`);
                }
                else {
                    name = (0, helper_1.toTitleCase)(nameSection);
                }
                return [
                    {
                        countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                        name,
                        phoneNo: "",
                        sortOrder: 1,
                    },
                ];
            }
        }
        return [];
    }
    getPharmacy(lines) {
        let name = "";
        let phoneNo = "";
        for (let i = 0; i < lines.length; i++) {
            const line = lines[i];
            // Preferred Pharmacy Name: Pharmcare - Pearland
            if (line.startsWith("Preferred Pharmacy Name:")) {
                name = line.replace("Preferred Pharmacy Name:", "").trim();
            }
            // Phone: (281) 996-7500 Fax: (281) 996-7636
            if (name && line.startsWith("Phone:")) {
                const phoneSection = line.replace("Phone:", "").split("Fax:")[0].trim();
                phoneNo = this.formatPhone(phoneSection);
                break;
            }
        }
        if (name) {
            return [
                {
                    countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                    name,
                    phoneNo,
                    sortOrder: 1,
                },
            ];
        }
        return [];
    }
    getCareGiver(lines) {
        var _a;
        let name = "";
        let phoneNo = "";
        for (let i = 0; i < lines.length; i++) {
            const line = lines[i];
            // Caregiver Name: Margie Bertram Relationship to Patient: Daughter
            if (line.startsWith("Caregiver Name:")) {
                const withoutPrefix = line.replace("Caregiver Name:", "");
                const namePart = withoutPrefix.split("Relationship")[0].trim();
                const relationshipPart = (_a = withoutPrefix
                    .split("Relationship to Patient:")[1]) === null || _a === void 0 ? void 0 : _a.trim();
                name = relationshipPart
                    ? `${namePart} (${relationshipPart})`
                    : namePart;
            }
            // Mobile: (281) 344-7751
            if (name && line.startsWith("Mobile:")) {
                const phoneSection = line.replace("Mobile:", "").trim();
                phoneNo = this.formatPhone(phoneSection);
                break;
            }
        }
        if (name) {
            return [
                {
                    countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                    name,
                    phoneNo,
                    sortOrder: 1,
                },
            ];
        }
        return [];
    }
    formatPhone(phone) {
        // Convert (281) 996-7500 to 281-996-7500
        const digits = phone.replace(/\D/g, "");
        if (digits.length === 10) {
            return (0, helper_1.changeNumberUSFormat)(digits);
        }
        return phone;
    }
}
exports.HospiceTools = HospiceTools;
